<template>
	<div class="columns is-multiline has-border-top is-padded-top is-padded-bottom is-mobile">
		<!-- Mobile -->
		<div class="is-hidden-desktop columns column is-marginless is-paddingless is-fullwidth">
			<div class="column is-paddingless">
				<div class="columns is-mobile">
					<div class="column is-three-quarters">
						<div class="column has-text-weight-bold is-paddingless">
							{{ card.number }}
						</div>
						<div v-if="activated" class="column is-paddingless">
							<span>
								{{ cardsTranslations.header.expiry_date }}: {{ formattedExpiryDate }}
							</span>
						</div>
						<div class="column is-paddingless">
							<span>{{ card.is_virtual ? cardsTranslations.types.virtual : cardsTranslations.types.physical }}</span>
						</div>
						<div class="column is-paddingless">
							<div v-if="activated" class="column has-text-weight-bold is-paddingless mt-3">
								<span>{{ cardsTranslations.header.card_status }}</span>
							</div>
							<div v-if="blocked">
								<i class="fa-solid fa-square has-text-danger"></i>
								<span class="is-capitalized">{{ card.status }}</span> ({{ formattedBlockingDate }})
							</div>
							<div v-else-if="activated">
								<i class="fa-solid fa-square has-text-success"></i>
								<span class="is-capitalized">{{ card.status }}</span> ({{ cardsTranslations.since }} {{ formattedActivationDate }})
							</div>
							<span v-else>
								<span class="is-capitalized">{{ card.status }}</span>
							</span>
							<i @touchstart="showCardInfo" class='fa-light fa-circle-info info-icon-color is-clickable' :card-info-popup="card.number" mobile="true"></i>
							<card-info-popup v-if="showCardMobile" v-bind="cardInfoPopupProps" :card-info-popup="card.number" mobile="true"/>
						</div>
					</div>
					<div class="column is-one-quarter is-flex is-justify-content-flex-end">
						<span v-if="isPartner" class="tag is-light has-text-weight-bold">
							<span class="is-capitalized">{{ cardsTranslations.partner }}</span>
						</span>
					</div>
				</div>
			</div>
			<div v-if="activated"  class="is-padded-top">
				<button class="button is-fullwidth is-size-6 track-action"
						@click="blockCard"
						data-ta-event="clientarea-track.employee.cards.card-block"
						data-ta-action="Click"
						data-ta-label="Employee-page – Cards – Click on Card Block"
						data-ta-page-name="EmployeeOverviewPage"
						:data-ta-payload="JSON.stringify({'cardId': card.card_id, 'name': card.addressLabel})"
				>
					{{ cardsTranslations.blocking.short }}
				</button>
			</div>
		</div>
		<!-- Desktop -->
		<div class="columns column is-hidden-touch">
			<div class="column has-text-weight-bold is-one-fifth">
				{{ card.number }}<span v-if="isPartner" class="tag is-light is-capitalized">{{ cardsTranslations.partner }}</span>
			</div>
			<div class="column is-one-fifth">
				<span v-if="!blocked" class="date">{{ formattedExpiryDate }}</span>
			</div>
			<div class="column is-one-fifth">
				<span>{{ card.is_virtual ? cardsTranslations.types.virtual : cardsTranslations.types.physical }}</span>
			</div>
			<div class="column is-one-fifth">
				<span v-if="blocked">
					<i class="fa-solid fa-square has-text-danger"></i>
					{{ translatedStatus }} ({{ formattedBlockingDate }})
				</span>
				<span v-else-if="activated">
					<i class="fa-solid fa-square has-text-success"></i>
					{{ translatedStatus }} ({{ cardsTranslations.since }} {{ formattedActivationDate }})
				</span>
				<span v-else>
					{{ translatedStatus }}
				</span>
				<span @mouseleave="hideCardInfo">
					<i @mouseover="showCardInfo" class='fa-light fa-circle-info info-icon-color' :card-info-popup="card.number"></i>
					<card-info-popup v-if="showCard" v-bind="cardInfoPopupProps" :card-info-popup="card.number"/>
				</span>
			</div>
			<div class="column has-text-right is-marginless is-one-fifth">
				<button v-if="activated" class="button is-small is-size-6 track-action"
						@click="blockCard"
						data-ta-event="clientarea-track.employee.cards.card-block"
						data-ta-action="Click"
						data-ta-label="Employee-page – Cards – Click on Card Block"
						data-ta-page-name="EmployeeOverviewPage"
						:data-ta-payload="JSON.stringify({'cardId': card.card_id, 'name': card.addressLabel})"
				>
					{{ cardsTranslations.blocking.short }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import date from "./mixins/dateFormatMixin";
export default {
	name: "card-item",
	mixins: [date],
	props: {
		card: {type:Object, required:true},
		cardsTranslations: Object,
		shippingAddressLabel: String
	},
	data() {
		return {
			showCard: false,
			showCardMobile: false,
			cardInfoPopupProps: {
				card: this.card,
				cardsTranslations: this.cardsTranslations,
				shippingAddressLabel: this.shippingAddressLabel,
			},
		}
	},
	methods: {
		showCardInfo(event) {
			if (event.target.attributes['mobile'])
			{
				this.showCardMobile = true;
			}
			else
			{
				this.showCard = true;
			}

		},
		hideCardInfo(event) {
			const cardNumber = event.target.attributes['card-info-popup'];
			if (!cardNumber	&& $(event.target).parents("[card-info-popup]").attr('card-info-popup') !== this.card.number
				|| cardNumber && cardNumber.nodeValue !== this.card.number)
			{
				this.showCardMobile = false;
				this.showCard = false;
			}
		},
		blockCard() {
			this.$emit('block-card');
		},
	},
	computed: {
		translatedStatus() {
			return this.cardsTranslations.status[this.card.status];
		},
		isPartner() {
			return this.card.isPartnerCard === 'Y';
		},
		created() {
			return this.card.status === 'created';
		},
		activated() {
			return this.card.status === 'activated';
		},
		blocked() {
			return this.card.status === 'blocked';
		},
		formattedExpiryDate() {
			return this.$options.filters.date(this.card.expiry);
		},
		formattedBlockingDate() {
			return this.$options.filters.date(this.card.blocking);
		},
		formattedActivationDate() {
			return this.$options.filters.date(this.card.activation);
		},
	},
	mounted() {
		document.addEventListener('click', this.hideCardInfo);
	},
	beforeDestroy() {
		document.removeEventListener('click', this.hideCardInfo);
	}
};
</script>
